<template>
  <div>
    <gs-alert-bar
      v-if="selectedPlan && otherStoresNeedSpendingLimitUpdate"
      class="mt-4"
      type="info"
      :title="t('update_other_stores_limit_title')"
      :message="t('update_other_stores_limit_description')"
    />
    <div class="button-wrapper">
      <gs-button @click="goToMyAccount" type="primary" size="large" full-width>
        {{ t('my_account') }}
      </gs-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import type { NewPaidBusinessSubscriptionType, PersonalSubscriptionType } from '@/helpers/pricing'
import { type Integration } from '@/store/integrations'

export default defineComponent({
  name: 'CustomSpendingLimitSuccess',
  emits: ['close'],
  computed: {
    userStores(): Integration[] {
      return this.$store.getters['getIntegrationsByPlatform']('shopify')
    },
    otherStoresNeedSpendingLimitUpdate(): boolean {
      if (this.userStores.length <= 1) {
        return false
      }

      return this.userStores.some(
        (store) =>
          store.spendingLimit?.activeLimit &&
          !store.spendingLimit?.pendingLimit &&
          !store.spendingLimit?.isPrimaryStore &&
          store.spendingLimit?.activeLimit < (store.spendingLimit?.min ?? 0),
      )
    },
  },
  methods: {
    t(key: string, params?: { [k: string]: string }) {
      return this.$t(`ShopifyCustomSpendingLimitView.${key}`, params || {})
    },
    async goToMyAccount() {
      if (document.documentElement.classList.contains('modal-open')) {
        document.documentElement.classList.remove('modal-open')
      }

      await this.$router.push({ path: '/account', query: { tab: 'billing' } })
      this.$emit('close')
    },
  },
  props: {
    selectedStore: {
      type: Object as PropType<Integration>,
      required: true,
    },
    selectedPlan: {
      type: String as PropType<NewPaidBusinessSubscriptionType | PersonalSubscriptionType>,
    },
  },
})
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 32px;
}
</style>
